import { render, staticRenderFns } from "./Pridelava.vue?vue&type=template&id=b26a4dfa&"
import script from "./Pridelava.vue?vue&type=script&lang=js&"
export * from "./Pridelava.vue?vue&type=script&lang=js&"
import style0 from "./Pridelava.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports